import { defineMessages } from 'react-intl';

/** Copy of Settings → Artist and Settings → SmartLinks (design artist-settings a, b). */
export const artistSettingsMessages = defineMessages({
  artistSubtitle: {
    id: 'app.sml.settings.artist.subtitle',
    defaultMessage:
      'The picture and the name fans see on every SmartLink of this artist: the bio link and each release page.',
  },
  activeArtistNote: {
    id: 'app.sml.settings.artist.activeNote',
    defaultMessage: 'You edit the artist that is open now. To edit another artist, pick it in the artist menu.',
  },
  saveArtist: { id: 'app.sml.settings.artist.save', defaultMessage: 'Save artist' },
  noArtistTitle: { id: 'app.sml.settings.artist.empty.title', defaultMessage: 'No artist in this workspace yet' },
  noArtistBody: {
    id: 'app.sml.settings.artist.empty.body',
    defaultMessage: 'Add an artist to give the SmartLinks a name and a picture.',
  },
  addArtist: { id: 'app.sml.settings.artist.empty.add', defaultMessage: 'Add artist' },
  smartLinksSubtitle: {
    id: 'app.sml.settings.smartlinks.subtitle',
    defaultMessage:
      'Where the SmartLinks of this artist live, and what measures them. The address and the trackers apply to every page.',
  },
  saveAddress: { id: 'app.sml.settings.smartlinks.save', defaultMessage: 'Save' },
});
